module.exports = __webpack_public_path__ + "static/media/8.d2a9a603.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/8.png
// module id = 1288
// module chunks = 0